import { render, staticRenderFns } from "./BuyNumberSection.vue?vue&type=template&id=3430d81e"
import script from "./BuyNumberSection.vue?vue&type=script&lang=js"
export * from "./BuyNumberSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports